import { render, staticRenderFns } from "./BusNew.vue?vue&type=template&id=1307aebf&"
import script from "./BusNew.vue?vue&type=script&lang=js&"
export * from "./BusNew.vue?vue&type=script&lang=js&"
import style0 from "./BusNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports